import * as React from 'react';
import {useCallback} from 'react';
import {ApprovalRequestForm} from 'components/approval/ApprovalRequestForm';

/**
 * The requester's own form. The same record and the same layout the manager
 * files for a student, minus the student picker: a justification and a levelled
 * competence are mandatory here, because `Create` files a self-submission
 * straight as pending, with no later editing step to complete it.
 */
export const StudentRequestFormPage = () => {
    const handleBack = useCallback(() => {
        window.location.href = '#/dashboard/requests';
    }, []);

    return <ApprovalRequestForm own onBack={handleBack}/>;
};
